export default ({ theme }) => `
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 10px 0;

    .stores-container {
      display: flex;
      width: 100%;
      justify-content: center;
      overflow-x: hidden;
    }

    .stores-masonry-container {
      position: relative;
      width: 100%;
      margin: 0 auto;

      .xblock {
        display: block;
      }
    }

    .header {
      width: calc(100% - 20px);
      display: flex;
      flex-direction: column;

      .description {
        display: flex;
        flex-direction: column;
        width: 100%;

        p.header-text {
          margin: 0;
          font-size: 20px;
        }
      }

      .sorter {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .visible-items {
          .matches {
            .matched-term {
              font-weight: bold;
              background: ${theme.alternateAccentColor};
              padding: 0 3px;
            }
          }
        }
      }
    }

    @media(max-width: 425px) {
      .header {
        .sorter {
          flex-direction: column;

          .visible-items {
            align-self: flex-start;
          }

          .dropdown-menu {
            width: 100% !important;
          }
        }
      }
    }
  `;
